import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../../types";
import { getApi } from "../../../apiPath";
import { axiosClient } from "../../../clients";

import type { IMembersScopusCandidate } from "./routeType";

const { key, getPath } = getApi("members.scopus.candidate.post");

type IExtractedRouteType =
  IMembersScopusCandidate["candidateScopusDataSingleConfirm"];

export type IPostMemberScopusCandidate = IPickMutation<IExtractedRouteType>;

const postMemberScopusCandidate: Fetcher<
  IPostMemberScopusCandidate["response"],
  IPostMemberScopusCandidate["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberScopusCandidate = createQuery({
  queryKey: [key],
  fetcher: postMemberScopusCandidate,
});
